import React from "react";
import ServicePage from "./Components/ServiceComponent";
import seoMarketingImage from "../../assets/img/standard-quality-control-concept-m.jpg";
import backgroundMark from "../../assets/img/contact-us_36325-2135.jpg";
import {
  FaPencilAlt,
  FaNetworkWired,
  FaProjectDiagram,
  FaMobileAlt,
} from "react-icons/fa";
import IntlMessages from "../../intl/IntlMessages";

const SEOAndMarketing = () => {
  return (
    <ServicePage
      title={<IntlMessages id="eventManagement.title" />}
      description={
        <div>
          <p>
            <IntlMessages id="process.textDescription" />
          </p>
          <p>
            <IntlMessages id="process.subTextDescription" />
          </p>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaMobileAlt size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="process.tech" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaProjectDiagram size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="process.annex" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaNetworkWired size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="process.media" />
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaPencilAlt size={24} />
              <span style={{ marginLeft: "0.5rem" }}>
                <IntlMessages id="process.benefit" />
              </span>
            </div>
          </div>
        </div>
      }
      imageUrl={seoMarketingImage}
      altText={<IntlMessages id="eventManagement.title" />}
      heroBackgroundImage={backgroundMark}
    />
  );
};

export default SEOAndMarketing;
